





































import { Component, Vue } from "vue-property-decorator"
import { mapState } from "vuex"

@Component({
  computed: {
    ...mapState({
      loading: "loading",
    }),
  },
})
export default class CandidateQuestionnaireGuardianInfo extends Vue {
  guardianName = ""

  emitSubmit() {
    this.$emit('submit', this.guardianName)
  }
}
